import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateArProfileSchema } from "@/v2/schema/ar-profile";
import { ArProfile } from "@/v2/types";

export default async function CreateArProfile(
    data: CreateArProfileSchema,
): Promise<ArProfile> {
    const res = await apiClientWithRefreshToken({
        url: `/ar-engineering-profile`,
        method: "POST",
        data,
    });
    return res.data;
}
